/**
 * Single source for build-time environment values.
 *
 * Nothing else in the app should read `process.env` directly. Keeping every read
 * here means a future move off Create React App (to Vite or anything else) changes
 * exactly one file instead of hunting call sites across the tree.
 */

export const BACKEND_URL: string = process.env.REACT_APP_BACKEND_URL ?? ''

export const IS_PRODUCTION: boolean = process.env.NODE_ENV === 'production'

/**
 * Google Pay environment (DES-16985).
 *
 * TEST draws a real button and returns an unchargeable payload. PRODUCTION charges real money.
 * Defaults to TEST, so a deploy that forgets the variable cannot open a live payment sheet.
 *
 * Neither value needs anything registered with Google by us. We draw the button through Cardknox's
 * iFields library, and Cardknox is the registered Google merchant - so there is no Google Pay &
 * Wallet Console registration and no integration review on our side, in either environment.
 */
export const GOOGLE_PAY_ENVIRONMENT: 'TEST' | 'PRODUCTION' =
  process.env.REACT_APP_GOOGLE_PAY_ENV === 'PRODUCTION' ? 'PRODUCTION' : 'TEST'

/**
 * The organisation's iFields key - the public half of their Cardknox credentials, safe in a web
 * page. Not MerchantLogin, the private key the server charges with; that must never reach here.
 *
 * OPTIONAL and normally empty: the flow was proven to charge with setAccount() skipped, because the
 * account charged is decided by the key the SERVER sends. See "The iFields key needs no home" in
 * google-pay.md.
 */
export const GOOGLE_PAY_IFIELDS_KEY: string = process.env.REACT_APP_GOOGLE_PAY_IFIELDS_KEY ?? ''

/** Google reCAPTCHA v2 site key. Empty means the Payment Link widget will not render. */
export const RECAPTCHA_SITE_KEY: string = (process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '').replace(
  /^['"]|['"]$/g,
  '',
)
